<script setup>
import { computed, inject } from 'vue';

const props = defineProps({
  index: {
    type: Number,
    default: 0,
  },
  name: {
    type: String,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  count: {
    type: Number,
    default: 0,
  },
  showBadge: {
    type: Boolean,
    default: true,
  },
  isCompact: {
    type: Boolean,
    default: false,
  },
});

const activeIndex = inject('activeIndex');
const updateActiveIndex = inject('updateActiveIndex');

const active = computed(() => props.index === activeIndex.value);
const getItemCount = computed(() => props.count);

const onTabClick = event => {
  event.preventDefault();
  if (!props.disabled) {
    updateActiveIndex(props.index);
  }
};
</script>

<template>
  <!-- Chat Storm: Restaurado mx-1 para margem menor entre tabs -->
  <li
    class="flex-shrink-0 my-0 mx-1 ltr:first:ml-0 rtl:first:mr-0 ltr:last:mr-0 rtl:last:ml-0 hover:text-n-slate-12"
  >
    <a
      class="flex items-center flex-row select-none cursor-pointer relative after:absolute after:bottom-px after:left-0 after:right-0 after:h-[2px] after:rounded-full after:transition-all after:duration-200 text-button whitespace-nowrap min-w-0"
      :class="[
        active
          ? 'text-n-blue-11 after:bg-n-brand after:opacity-100'
          : 'text-n-slate-11 after:bg-transparent after:opacity-0',
        // Chat Storm: py-1.5 text-xs para fonte e padding menores (compacto)
        isCompact ? 'py-1.5 text-xs' : '!text-base py-3',
      ]"
      @click="onTabClick"
    >
      <!-- Chat Storm: o nome trunca quando falta espaco, em vez de forcar rolagem -->
      <span class="truncate">{{ name }}</span>
      <div
        v-if="showBadge"
        class="rounded-full h-5 flex items-center justify-center flex-shrink-0 font-medium my-0 py-0"
        :class="[
          active
            ? 'bg-n-blue-3 text-n-blue-11'
            : 'bg-n-alpha-1 text-n-slate-10',
          // Chat Storm: no modo compacto o badge tem tamanho fixo em px, igual ao
          // texto da aba, para nao crescer junto com a fonte do usuario
          isCompact
            ? 'ltr:ml-1 rtl:mr-1 px-1 min-w-[18px] text-[11px]'
            : 'ltr:ml-1 rtl:mr-1 px-1.5 min-w-[20px] text-xs',
        ]"
      >
        <span>
          {{ getItemCount }}
        </span>
      </div>
    </a>
  </li>
</template>
